import {
  SET_TICKER_INFO,
  UPDATE_STOCK_INPUT,
  UPDATE_SUMMARY_INPUT,
  UNAUTH_USER,
  SOCKET_UPDATE,
  SET_CHART_INFO,
  SET_TICKER_SEARCH_INFO,
  SET_TRADE_HISTORY_INFO,
  SET_TICKER_NEWS_INFO,
  TOGGLE_TICKER_STRIKETHROUGH,
  REMOVE_TRADE_HISTORY_ITEM,
  UPDATE_TRADE_HISTORY_INPUT,
  UPDATE_SPX_QUARTERLY
} from '../actions/types';

const INIT_STATE = {
  tickerInfo: [],
  sectorInfo: [],
  quarterInfo: {},
  benchmarkInfo: [],
  tickers: [],
  chartInfo: [],
  tickerNewsInfo: [],
  tickerSearchInfo: {},
  tradeHistoryInfo: [],
  customizations:[]
};

export default function(state = INIT_STATE, action) {
  switch (action.type) {
    case SET_TICKER_INFO: {
      const {
        tickerInfo,
        sectorInfo,
        quarterInfo,
        benchmarkInfo,
        tickers,
        customizations

      } = action.payload.data;
      return {
        ...state,
        tickerInfo,
        sectorInfo,
        quarterInfo,
        benchmarkInfo,
        tickers,
        customizations
      };
    }
    case SOCKET_UPDATE: {
      const { price, ticker, section } = action.payload;
      const newState = [...state[section]].map(item => {
        if (item.symbol === ticker) {
          item.price = price;
        }
        return item;
      });
      return {
        ...state,
        [section]: newState
      };
    }
    case TOGGLE_TICKER_STRIKETHROUGH:
      const { symbol, flag } = action.payload;
      const newState = [...state.tickerInfo].map(item => {
        if (item.symbol === symbol) {
          item.strikethrough = flag;
        }
        return item;
      });
      return {
        ...state,
        tickerInfo: newState
      };
    case SET_TICKER_NEWS_INFO: {
      return {
        ...state,
        tickerNewsInfo: action.payload
      };
    }
    case SET_TRADE_HISTORY_INFO: {
      return {
        ...state,
        tradeHistoryInfo: action.payload
      };
    }
    case REMOVE_TRADE_HISTORY_ITEM: {
      return {
        ...state,
        tradeHistoryInfo: state.tradeHistoryInfo.filter(
          item => item.id !== action.payload
        )
      };
    }
    case UPDATE_TRADE_HISTORY_INPUT: {
      const { tradeId, name, value } = action.payload;
      const newState = [...state.tradeHistoryInfo].map(item => {
        if (item.id === tradeId) {
          item[name] = value;
        }
        return item;
      });
      return {
        ...state,
        tradeHistoryInfo: newState
      };
    }
    case UPDATE_SPX_QUARTERLY: {
      const { symbol, value } = action.payload
      const newBenchmarkInfo = [...state.benchmarkInfo].map(item => {
        if (item.symbol === symbol) {
          item.quarterly = value
        }
        return item
      })
      return {
        ...state,
        benchmarkInfo: newBenchmarkInfo
      }
    }
    case SET_CHART_INFO: {
      return {
        ...state,
        chartInfo: action.payload
      };
    }
    case SET_TICKER_SEARCH_INFO: {
      return {
        ...state,
        tickerSearchInfo: action.payload
      };
    }
    case UPDATE_SUMMARY_INPUT: {
      return {
        ...state,
        quarterInfo: {
          ...state.quarterInfo,
          [action.payload.name]: action.payload.value
        }
      };
    }
    case UPDATE_STOCK_INPUT: {
      const { value, name, symbol, section } = action.payload;
      const newTickerInfo = [...state[section]].map(item => {
        if (item.symbol === symbol) {
          item[name] = value;
        }
        return item;
      });
      return {
        ...state,
        newTickerInfo
      };
    }
    case UNAUTH_USER: {
      return {
        tickerInfo: [],
        sectorInfo: [],
        quarterInfo: {},
        benchmarkInfo: [],
        chartInfo: [],
        tickerNewsInfo: [],
        tickers: [],
        tickerSearchInfo: {},
        tradeHistoryInfo: [],
        customizations:[]

      };
    }
    default:
      return state;
  }
}
